import { Button } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  // MED-1687: the page was hard-coded in English, with a blue button outside the logo colours
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100">
      <div className="p-8 max-w-md text-center bg-white rounded-lg shadow-md">
        <h1 className="mb-4 text-6xl font-bold text-red-500">404</h1>
        <h2 className="mb-4 text-2xl font-semibold text-gray-800">
          {t("common.notFoundPage.title")}
        </h2>
        <p className="mb-6 text-gray-600">{t("common.notFoundPage.description")}</p>
        <Button onClick={() => navigate("/dashboard")}>{t("common.notFoundPage.back")}</Button>
      </div>
    </div>
  );
};

export default NotFound;
